import { render, staticRenderFns } from "./HandicapPromChannelData.vue?vue&type=template&id=b7a76a06&scoped=true"
import script from "./HandicapPromChannelData.vue?vue&type=script&lang=js"
export * from "./HandicapPromChannelData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a76a06",
  null
  
)

export default component.exports